import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageJournal: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation()
    return (
        <ManageBooks
            button_add_name={t("เพิ่มวารสาร")}
            category={ELibraryCategory.MAGAZINE}
            menu_name={t('จัดการวารสาร')}
            path_create={routeName.e_library.manage_journal_create}
        />
    )
}

export default ManageJournal